export const rejectedDefaultMail = `Dear Candidate

Thank you for applying for the position. We appreciate the time and effort you invested in the process.

After careful review, we have chosen to move forward with another candidate. This was a difficult decision, as we were impressed by your qualifications.

Please feel free to apply for future roles that align with your experience. We wish you all the best in your job search and career.

Regards,`;

export const selectedDefaultMail = `Dear Candidate,

Congratulations! You have been selected to move forward to the next step in our hiring process. Our team will reach out soon to schedule this, and we're excited to continue the conversation.

Looking forward to speaking with you again!

Regards,`;

export const mailformat =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;